
export const apiUrl = process.env.REACT_APP_OPENBANKING_API_URL ?? window._env_.REACT_APP_OPENBANKING_API_URL;
export const apiCrypto = process.env.REACT_APP_CRYPTOSERVICE_API_URL ?? window._env_.REACT_APP_CRYPTOSERVICE_API_URL;
export const functionUrl = process.env.REACT_APP_OPENBANKING_FUNCTION_URL ?? window._env_.REACT_APP_OPENBANKING_FUNCTION_URL;
export const subscription_key = process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY ?? window._env_.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY;
